var exports = {
  "C9": "NekoSprite.module__neko___cWR5Qn",
  "Hm": "NekoSprite.module__heart___cWR5Qn",
  "kn": "NekoSprite.module__nekoHeartFloat___cWR5Qn",
};

module.exports = exports;
